// extracted by mini-css-extract-plugin
var _1 = "ClampingTextContentNodeClamp-moduleClampingTextContentNodeClamp__heENG";
var _2 = "ClampingTextContentNodeClamp-modulemeasureContainer__XmaMo";
var _3 = "ClampingTextContentNodeClamp-moduletail__IjOY9";
var _4 = "ClampingTextContentNodeClamp-moduletext__xxm4h ClampingText-moduleclampingText__ANX4H";
var _5 = "ClampingTextContentNodeClamp-moduletextContainer__iAuZ7";
export { _1 as "ClampingTextContentNodeClamp", _2 as "measureContainer", _3 as "tail", _4 as "text", _5 as "textContainer" }
